import React, { Fragment, useEffect, useState } from "react";
import { Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, FormLabel, Grid, InputAdornment, List, ListItem, ListItemText, Paper, Radio, RadioGroup, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip } from "@material-ui/core";
import { globalGetService, globalPostService, globalPutService } from "../../../../globalServices";
import { checkApiStatus, checkPermission } from "../../../utils_v2";
import { trackActivity } from "../../../../utils/mixpanel";
import { PageLoader } from "../../../shared_elements";
import { useSnackbar } from "notistack";
import { Autocomplete } from "@material-ui/lab";
import { regexConstants } from "../../../../constants/regEx";
import ErrorPopUp from "../../../shared_elements/ErrorPopUp";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import NoAccess from "../../aircraftModels/components/NoAccess";

const AddEditLlpParts = ({ params, toggleModalFn, addEditLlpParts, modeType, getResponseBack }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [data, setData] = useState({ ...addEditLlpParts?.data, is_hour_cycle: addEditLlpParts?.data?.is_hour_cycle ?? "CY" });
    const [error, setError] = useState({ modal: false, data: null });
    const [isLoading, setLoading] = useState(false);
    const [moduleInfo, setModuleInfo] = useState([]);
    const [description, setDescription] = useState([])
    const [moduleData, setModuleData] = useState([]);
    const [linkEngine, setLinkEngine] = useState({ modal: false, data: null })
    const [search, setSearch] = useState('');
    const [checked, setChecked] = useState([]);
    const [listing, SetListing] = useState({ list: [] });
    const [linkEngineInfo, setLinkEngineInfo] = useState(addEditLlpParts?.data?.linked_engine);
    const [circularloader, setCircularloader] = useState(false);

    useEffect(() => {
        if (modeType === 'add' || modeType === 'edit') {
            getModule();
            getPopupList();
        }
    }, []);

    const getPopupList = () => {
        globalGetService(`config-data/engine-type/?lite=true`)
            .then(response => {
                if (checkApiStatus(response)) {
                    SetListing(response?.data)
                }
            })
    }

    const handleToggle = (value) => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };
    const onFieldChange = (key, value) => {
        let updatedData = { ...data, [key]: value };
        if (key === 'module') {
            const selectedModule = moduleData.find(module => module.id === value?.id);
            const descList = selectedModule?.description?.map(desc => ({
                id: desc?.id,
                name: desc?.name
            })) || [];

            setDescription(descList);
            updatedData['description'] = null;
        }
        setData(updatedData);
    };
    const onLinkedEngineFieldChange = (index, key, value) => {
        let updatedData = [...linkEngineInfo];
        updatedData[index] = {
            ...updatedData[index], [key]: value
        };
        setLinkEngineInfo(updatedData);
    };

    const LinkEngineType = () => {
        const currentEngines = Array.isArray(linkEngineInfo) ? linkEngineInfo : [];
        const currentChecked = Array.isArray(checked) ? checked : [];
        const existingIds = new Set(currentEngines.map(item => item.id));
        const newItems = currentChecked.filter(item => !existingIds.has(item.id));
        setLinkEngineInfo([...currentEngines, ...newItems]);
        setChecked([]);
        setLinkEngine({ modal: false, data: null });
        setSearch("")
    }

    const onRemove = (index) => {
        setLinkEngineInfo(linkEngineInfo.filter((item, itemIndex) => itemIndex !== index))
        setChecked(checked.filter((item, itemIndex) => itemIndex !== index))
    }

    const getModule = () => {
        globalGetService(`config-data/llp-module/?lite=true`)
            .then(response => {
                if (checkApiStatus(response)) {
                    let moduleInfo = [];
                    const data = response?.data?.data?.list;
                    data.map((item) => {
                        moduleInfo.push({ id: item?.id, name: item?.name });
                    });
                    setModuleInfo(moduleInfo);
                    setModuleData(data);
                    if (modeType === 'edit' && addEditLlpParts?.data?.module?.id) {
                        const selectedModule = data.find(m => m.id === addEditLlpParts.data.module.id);
                        const descList = selectedModule?.description?.map(desc => ({ id: desc?.id, name: desc?.name })) || [];
                        setDescription(descList);
                    }
                }
            });
    };

    const isDataChanged = () => {
        const originalData = addEditLlpParts?.data || {};
        return (
            data?.module?.id !== originalData?.module?.id ||
            data?.description?.id !== originalData?.description?.id ||
            data?.part_number !== originalData?.part_number ||
            data?.remarks !== originalData?.remarks ||
            data?.is_hour_cycle !== originalData?.is_hour_cycle
        )
    };

    const isLinkedEngineChanged = () => {
        const original = addEditLlpParts?.data?.linked_engine || [];
        const current = linkEngineInfo || [];

        if (original.length !== current.length) return true;

        return current.some((curr, index) => {
            const orig = original[index];

            return (
                curr?.engine_type?.id !== orig?.engine_type?.id ||
                parseFloat(curr?.limit) !== parseFloat(orig?.limit) ||
                curr?.escalation_percentage !== orig?.escalation_percentage ||
                curr?.cost !== orig?.cost ||
                curr?.year_of_cost !== orig?.year_of_cost
            );
        });
    };


    const onAddEditLlpParts = () => {
        let validationInputs = {
            module: data?.module ? '' : 'Please Select Module',
            part_number: data?.part_number?.trim() ? '' : 'Please enter Part Number',
            description: data?.description ? '' : "Please select Description",
        };

        if (!linkEngineInfo?.length) {
            enqueueSnackbar("Please link the Engine Type to proceed", {
                variant: 'error',
                anchorOrigin: { vertical: 'top', horizontal: 'right' }
            });
            return;
        }

        let errors = {
            limit: [],
            escalation: [],
            costWithoutYear: [],
            yearWithoutCost: []
        };
        linkEngineInfo.forEach((item, i) => {
            const row = i + 1;
            if (!item?.limit?.toString()?.trim()) errors.limit.push(row);
            if (parseFloat(item?.escalation_percentage) > 100) errors.escalation.push(row);
            if (item?.cost && !item?.year_of_cost) errors.costWithoutYear.push(row);
            if (item?.year_of_cost && !item?.cost) errors.yearWithoutCost.push(row);
        });
        const errorMessages = [];
        if (errors.limit.length) errorMessages.push(`Please Enter ${data?.is_hour_cycle === "HR" ? 'Hour': "Cycle"} Limit for row (${errors.limit.join(', ')})`);
        if (errors.escalation.length) errorMessages.push(`Escalation % can't be more than 100% for row (${errors.escalation.join(', ')})`);
        if (errors.costWithoutYear.length) errorMessages.push(`Please Enter Year of Cost for row (${errors.costWithoutYear.join(', ')}) `);
        if (errors.yearWithoutCost.length) errorMessages.push(`Please Enter Cost for row (${errors.yearWithoutCost.join(', ')})`);
        if (errorMessages.length) {
            enqueueSnackbar(errorMessages.join(' & '), { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
            setError(validationInputs);
            return;
        }

        const hasBasicError = Object.values(validationInputs).some(val => val !== '');

        if (!hasBasicError) {
            setLoading(true);

            let payload = {
                id: data?.id || null,
                module: data?.module || null,
                description: data?.description || null,
                part_number: data?.part_number || null,
                is_hour_cycle: data?.is_hour_cycle === "HR" ? "HR" : "CY",
                remarks: data?.remarks || null,
                linked_engine: linkEngineInfo.map(linkedEngine => ({
                    engine_type: linkedEngine?.engine_type ? linkedEngine?.engine_type : { name: linkedEngine?.name, id: linkedEngine?.id } || null,
                    limit: linkedEngine?.limit ? parseFloat(linkedEngine?.limit) : null,
                    escalation_percentage: linkedEngine?.escalation_percentage ? parseFloat(linkedEngine?.escalation_percentage) : 0.00,
                    cost: linkedEngine?.cost ? parseFloat(linkedEngine?.cost).toFixed(2) : null,
                    year_of_cost: linkedEngine?.year_of_cost ? linkedEngine?.year_of_cost : null
                }))
            };

            const apiUrl = data?.id ? `config-data/llp/bulk-update/` : `config-data/llp/`;
            const apiMethod = data?.id ? globalPutService : globalPostService;

            apiMethod(apiUrl, [payload])
                .then((response) => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response?.data?.message, {
                            variant: 'success',
                            anchorOrigin: { vertical: 'top', horizontal: 'right' }
                        });
                        toggleModalFn();
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Console Management', {
                            event_desc: data?.id ? 'LLP Part Updated Successfully' : 'LLP Part Added Successfully',
                            page_title: 'Config Data : LLP Part',
                            event_type: data?.id ? 'Item Updated' : 'Item Added',
                            updated_id: data?.id || null,
                            success_msg: response?.data?.message,
                            data:JSON.stringify(payload)
                        });
                    } else {
                        getResponseBack();
                        setError({ modal: true, data: response?.data?.error_details });
                        setLoading(false);
                        trackActivity('Console Management', {
                            event_desc: data?.id ? 'LLP Part Updation Failed' : 'LLP Part Added Failed',
                            page_title: 'Config Data : LLP Part',
                            event_type: data?.id ? 'Item Updated' : 'Item Added',
                            item_id: data?.id || null,
                            error_msg: response?.data?.message,
                            data:JSON.stringify(payload)
                        });
                    }
                });
        } else {
            setError(validationInputs);
        }
    };

    return (
        <>
            <Dialog
                open={true}
                className='console-management-modal'
                maxWidth='xl'
            >
                <DialogTitle id="scroll-dialog-title">
                    {modeType === 'edit' ? 'Edit ' : modeType === 'view' ? 'View' : 'Add '} LLP Part
                </DialogTitle>
                <DialogContent dividers style={{ width: "1100px" }}>
                    <div>
                        <Grid container spacing={1}>
                            <Grid item md={4} >
                                <Autocomplete
                                    options={(moduleInfo || []).filter((item) => item.id !== data?.module?.id)}
                                    getOptionLabel={option => option?.name || ''}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    id="module"
                                    disabled={modeType === 'view'}
                                    value={data?.module || null}
                                    disableClearable={true}
                                    onFocus={() => setError({ ...error, module: '' })}
                                    onChange={(e, value) => { onFieldChange('module', value); }}
                                    renderInput={params => <TextField placeholder={'Please select module'}  {...params} label={'Module'} error={error?.module || ''} helperText={error?.module || ''} margin="normal" required fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                />
                            </Grid>
                            <Grid item md={4} >
                                <Autocomplete
                                    options={description || []}
                                    getOptionLabel={option => option?.name || ''}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    id="description"
                                    disabled={modeType === 'view' || !data?.module}
                                    value={data?.description || null}
                                    disableClearable={true}
                                    onFocus={() => setError({ ...error, description: '' })}
                                    onChange={(e, value) => { onFieldChange('description', value); }}
                                    renderInput={params => <TextField placeholder={'Please select description'}  {...params} label={'Description'} error={error?.description || ''} helperText={error?.description || ''} margin="normal" required fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                />
                            </Grid>
                            <Grid item md={4}>
                                <TextField
                                    name='part_number'
                                    label='Part Number'
                                    disabled={modeType === 'view'}
                                    required={modeType !== 'view'}
                                    value={data?.part_number || ''}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 15 }}
                                    onChange={(e) => regexConstants.alphanumericWithHyphen.test(e.target.value) ? onFieldChange('part_number', e.target.value) : e.preventDefault}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                    error={error?.part_number || ''}
                                    helperText={error?.part_number || ''}
                                    onFocus={() => setError({ ...error, part_number: '' })}
                                />
                            </Grid>
                            <Grid item md={12} >
                                <TextField
                                    name='remarks'
                                    label='Remarks'
                                    disabled={modeType === 'view'}
                                    value={data?.remarks || ''}
                                    fullWidth
                                    margin="normal"
                                    multiline
                                    rows={3}
                                    inputProps={{ maxLength: 255 }}
                                    onChange={(e) => onFieldChange('remarks', e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                        </Grid>

                        {checkPermission('config_data', 'engine_types', 'R') ?  <Paper>
                            {checkPermission('config_data', 'engine_types', 'U')?  <Grid container spacing={1} className="flex-centered" style={{ padding: "10px 5px" }}>
                                <Grid item md={6}>
                                    <FormControl component="fieldset">
                                        <RadioGroup row aria-label="limitType" name="is_hour_cycle">
                                            <FormControlLabel value="is_hour_cycle" control={<Radio checked={data?.is_hour_cycle === "CY"} onChange={(e) => onFieldChange('is_hour_cycle', "CY")} color="primary" size="small" />} label="Cycle Limit" />
                                            <FormControlLabel value="is_hour_cycle" control={<Radio checked={data?.is_hour_cycle === "HR"} onChange={(e) => onFieldChange('is_hour_cycle', "HR")} color="primary" size="small" />} label="Hour Limit" />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                                <Grid item md={6} >
                                    <ul style={{ textAlign: "right" }}>
                                        <li className='list-inline-item'>
                                            <Button onClick={() => setLinkEngine({ modal: true, data: listing })} color="primary" size='small' variant="contained">Link Engine Type</Button>
                                        </li>
                                    </ul>
                                </Grid>
                            </Grid> : <div style={{marginTop:"12px"}}></div>}
                            <Table className='mui-table-format ' stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell><div style={{ width: "200px" }}>Engine Type</div></TableCell>
                                        <TableCell><div style={{ width: "150px" }}>{data?.is_hour_cycle === 'CY' ? 'Cycle' : 'Hour'} Limit *</div></TableCell>
                                        <TableCell><div style={{ width: "150px" }}>Escalation %</div></TableCell>
                                        <TableCell><div style={{ width: "200px" }}>Replacement Cost</div></TableCell>
                                        <TableCell><div style={{ width: "140px" }}>Year of Cost</div></TableCell>
                                        <TableCell><div >Action</div></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {linkEngineInfo?.map((item, index) =>
                                        <TableRow key={index} style={{ verticalAlign: 'text-bottom' }}>
                                            <TableCell style={{ alignContent: 'center' }}><div style={{ width: "200px" }}>{item?.engine_type?.name ? item?.engine_type?.name : item?.name}</div></TableCell>
                                            <TableCell>
                                                <TextField
                                                    name={`limit_${index}`}
                                                    value={item?.limit || ''}
                                                    onChange={(e) => (data.is_hour_cycle === "CY" ? regexConstants.numberNoSpace : regexConstants.decimalnodotstart).test(e.target.value) ? onLinkedEngineFieldChange(index, 'limit', e.target.value) : e.preventDefault()}
                                                    fullWidth
                                                    style={{ width: "150px" }}
                                                    margin="none"
                                                    inputProps={{ maxLength: 10 }}
                                                    InputLabelProps={{ shrink: true }}
                                                    variant='outlined'
                                                    error={error?.limit || ''}
                                                    helperText={error?.limit || ''}
                                                    onFocus={() => setError({ ...error, limit: '' })}
                                                    disabled={!(checkPermission('config_data', 'engine_types', 'C') || checkPermission('config_data', 'engine_types', 'U'))}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <TextField
                                                    name={`escalation_percentage_${index}`}
                                                    value={item?.escalation_percentage || ''}
                                                    onChange={(e) => regexConstants.numberWithDot5.test(e.target.value) ? onLinkedEngineFieldChange(index, 'escalation_percentage', e.target.value) : e.preventDefault()}
                                                    fullWidth
                                                    style={{ width: "150px" }}
                                                    margin="none"
                                                    inputProps={{ maxLength: 8 }}
                                                    InputLabelProps={{ shrink: true }}
                                                    variant='outlined'
                                                    disabled={!(checkPermission('config_data', 'engine_types', 'C') || checkPermission('config_data', 'engine_types', 'U'))}

                                                />
                                            </TableCell>
                                            <TableCell >
                                                <TextField
                                                    name={`cost_${index}`}
                                                    fullWidth
                                                    style={{ width: "200px" }}
                                                    inputProps={{ maxLength: 12 }}
                                                    margin="none"
                                                    value={item?.cost || ''}
                                                    onChange={(e) => regexConstants.decimalnodotstart.test(e.target.value) ? onLinkedEngineFieldChange(index, 'cost', e.target.value) : e.preventDefault()}
                                                    InputLabelProps={{ shrink: true }}
                                                    variant='outlined'
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start" >
                                                                $
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                    disabled={!(checkPermission('config_data', 'engine_types', 'C') || checkPermission('config_data', 'engine_types', 'U'))}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                                    <KeyboardDatePicker
                                                        margin="normal"
                                                        id="year_of_cost"
                                                        format="YYYY"
                                                        fullWidth
                                                        style={{ marginTop: '0px', width: "140px" }}
                                                        disableFuture
                                                        InputLabelProps={{ shrink: true }}
                                                        value={item?.year_of_cost ? moment(`${item.year_of_cost}`, 'YYYY') : null}
                                                        onChange={(date) => onLinkedEngineFieldChange(index, 'year_of_cost', date?.year())}                                                    // onFocus={() => setError({ ...error, 'invoice_for_date': '' })}
                                                        placeholder='Select/Enter Year of Cost'
                                                        inputVariant="outlined"
                                                        views={['year']}
                                                        disabled={!(checkPermission('config_data', 'engine_types', 'C') || checkPermission('config_data', 'engine_types', 'U'))}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </TableCell>
                                            {checkPermission('config_data', 'engine_types', 'D') &&   <TableCell style={{ alignContent: 'center' }} >
                                                <Tooltip title='Remove' arrow><HighlightOffIcon color="secondary" fontSize="small" style={{ cursor: "pointer" }} onClick={() => onRemove(index)} /></Tooltip>
                                            </TableCell>}
                                        </TableRow>)}
                                </TableBody>
                            </Table>
                        </Paper>: null}

                       
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { toggleModalFn(); trackActivity('Console Management', { page_title: 'Config Data : LLP Part', item_type: 'Cancel Button', event_type: 'Item Clicked', event_desc: `Clicked on Cancel Button from ${modeType === 'add' ? 'Add' : modeType === 'view' ? 'View' : 'Edit'} LLP Part form` }) }} color='primary' size='small' variant='outlined'>Cancel</Button>
                    {modeType === 'view' ? null : <Button onClick={() => { onAddEditLlpParts(); trackActivity('Console Management', { page_title: 'Config Data : LLP Part', item_type: 'Save Button ', event_type: 'Item Clicked', event_desc: `Clicked on Save Button from ${modeType === 'add' ? 'Add' : 'Edit'} LLP Part form` }) }} disabled={isLoading || (modeType === 'edit' && !isDataChanged() && !isLinkedEngineChanged())} color='primary' size='small' variant='contained'>{isLoading ? <CircularProgress size={24} /> : 'Save'}</Button>}
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
            {error?.data?.map((item) =>
                <ErrorPopUp
                    toggleModalFn={() => setError({ modal: false, data: null })}
                    modal={error.modal}
                    error={item} />
            )}

            {linkEngine.modal &&
                <Dialog className='console-management-modal' maxWidth="md" style={{ maxHeight: "600px" }} open={true}>
                    <DialogTitle>Link Engine Type</DialogTitle>
                    <DialogContent dividers style={{ width: "500px", paddingTop: "0px" }}>
                        <div style={{ position: "sticky", top: "0", zIndex: "1", background: '#fff', padding: '12px' }}>
                            <Paper>
                                <TextField
                                    fullWidth
                                    placeholder={"Search..."}
                                    variant='outlined'
                                    size='small'
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                            </Paper>
                        </div>
                        <List>
                            {listing?.data?.length && (listing?.data || []).filter(entry => entry?.name?.toLowerCase().includes(search.toLowerCase())).length === 0 ? (
                                <p style={{ textAlign: "center" }}>No results found</p>
                            )
                                :
                                ((listing?.data || []).filter(entry => entry?.name?.toLowerCase().includes(search.toLowerCase()) && !linkEngineInfo?.some(e => (e.id === entry.id || e.engine_type?.id === entry.id))).map((entry, index) => (
                                    <Fragment key={index}>
                                        <ListItem button onClick={() => handleToggle(entry)} dense>
                                            <Checkbox
                                                edge="start"
                                                checked={checked.some(item => item.id === entry.id)}
                                                tabIndex={-1}
                                                disableRipple
                                                color="primary"
                                            />
                                            <ListItemText primary={entry.name} />
                                        </ListItem>
                                        <Divider />
                                    </Fragment>
                                ))
                                )}
                        </List>
                        <p>{!listing?.data?.length ? <div style={{ textAlign: "center" }}>{description}</div> : null}</p>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { setLinkEngine({ modal: false, data: null });setSearch(""); setChecked([]); trackActivity('Console Management', { page_title: 'Config Data : LLP Part', item_type: 'Cancel Button', event_type: 'Item Clicked', event_desc: `Clicked on Cancel Button from Engine Type Linking Modal` }) }} color='primary' size='small' variant='outlined'>Cancel</Button>
                        <Button variant="contained" size='small' onClick={() => { LinkEngineType(); trackActivity('Console Management', { page_title: 'Config Data : LLP Part', item_type: 'Linked Button', event_type: 'Item Clicked', event_desc: `Clicked on link Button from Engine Type Linking Modal` }); }} disabled={isLoading || !checked.length} color="primary" >
                            {circularloader ? <CircularProgress size={20} /> : 'Link'}
                        </Button>
                    </DialogActions>
                </Dialog>
            }
        </>
    )
}

export default AddEditLlpParts